import { Timestamp, GeoPoint } from "firebase/firestore";

/**
 * Bar Suggestion Status
 */
export enum BarSuggestionStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  DUPLICATE = "duplicate",
}

/**
 * Bar Suggestion Interface
 * Ein von einem User gemeldeter fehlender Standort.
 */
export interface BarSuggestion {
  id: string;
  userId: string;
  userName: string;
  userEmail?: string;
  status: BarSuggestionStatus;

  // Bar-Daten
  barName: string;
  address?: string;
  city?: string;
  postalCode?: string;
  latitude: number;
  longitude: number;
  location?: GeoPoint;

  // OSM-Referenz
  osmId?: string;
  osmAmenityType?: string;

  // Aus Koordinaten abgeleitete Standortdaten
  resolvedAddress?: string;
  resolvedCity?: string;
  resolvedPostalCode?: string;
  resolvedDisplayName?: string;
  resolvedFromCoordinates?: boolean;

  // Vom Admin manuell neu geokodierter Standort
  manualLocationOverride?: boolean;
  locationUpdatedAt?: Timestamp;
  locationUpdatedBy?: string;

  // Mit einer bereits bestehenden Bar zusammengeführt (statt neu angelegt)
  mergedIntoBarId?: string;

  // Zusatzinfos
  notes?: string;

  // Admin-Felder
  reviewedBy?: string;
  reviewedAt?: Timestamp;
  rejectionReason?: string;
  createdBarId?: string;

  // Timestamps
  createdAt: Timestamp;
}
